import { BaseModel } from "sjs-base-model";
import KaikoItemModel from "./KaikoItemModel";

// Returned Api Data sample
// const example = {
//     exchanges: ["FTX", "BlockFi", "3AC", "Voyager Digital"],
//     baseCurrencies: ["BTC"]
// };

export default class KaikoParametersModel extends BaseModel {
    levelOne = [KaikoItemModel];
    levelTwo = [KaikoItemModel];

    constructor(data) {
        super();
        this.update(data);
    }
}
